module.exports = __webpack_public_path__ + "img/mlogo_red_1rgb.db2795e4.svg";